export function setLayout(layout) {
  return {
    type: 'SET_LAYOUT',
    payload: layout
  };
}
export function setLoading(isLoading) {
  return {
    type: 'SET_LOADING',
    payload: isLoading
  };
}
export function setError(isError) {
  return {
    type: 'SET_ERROR',
    payload: isError
  };
}
export function setContact(contact) {
  return {
    type: 'SET_CONTACT',
    payload: contact
  };
}
export function setComparisonStatus(offerId, status) {
  return {
    type: 'SET_COMPARISON_STATUS',
    payload: {
      offerId,
      status
    }
  };
}
export function setFavoriteStatus(offerId, isFavorite) {
  return {
    type: 'SET_FAVORITE_STATUS',
    payload: {
      offerId,
      isFavorite
    }
  };
}